import * as Sentry from '@sentry/browser';
import type { ScopeContext, SeverityLevel } from '@sentry/types';

type LoggerFn = (
  message: string,
  context?: Partial<Pick<ScopeContext, 'extra' | 'tags' | 'fingerprint'>> & {
    cause?: any;
  },
) => string;
type Logger = Record<SeverityLevel, LoggerFn>;

const log =
  (severity: SeverityLevel): LoggerFn =>
  (message, context) => {
    return Sentry.withScope(scope => {
      const { cause, ...captureContext } = context ?? {};
      scope.setLevel(severity);

      const loggableError = new Error(message);
      if (cause) {
        // @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/cause
        loggableError.cause = cause;
      }

      return Sentry.captureException(loggableError, captureContext);
    });
  };

export const logger: Logger = {
  debug: log('debug'),
  info: log('info'),
  log: log('log'),
  warning: log('warning'),
  error: log('error'),
  fatal: log('fatal'),
};
